import angular from 'angular';

import '../../core/main/factory/feature';
import './authentication';

angular
    .module("merchant.application.main")
    .factory("merchant.application.main.factory.assignedDevice", [
        "merchant.application.main.factory.authentication",
        "core.application.main.factory.feature",
        function (Authentication, Feature) {
            var posWithoutSecrets = null;
            var loadFlags = function () {
                Feature.retrieveFeatureFlagPromise("standalone-pos-without-secrets", false)
                    .then(function (flag) {
                        posWithoutSecrets = flag;
                    });
            };

            loadFlags();

            return {
                standalonePosDevice: function () {
                    if (posWithoutSecrets) {
                        return Authentication.standalonePosDevice();
                    }
                }
            }
        }
    ]);
